import { initializeIcons } from '@fluentui/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import MainApp from './app/routes/MainApp/MainApp';
import * as serviceWorker from './serviceWorker';
import { auth } from './shared/auth/auth';
import WebFont from 'webfontloader';
import './index.scss';

WebFont.load({
  google: {
    families: ['Raleway:400,500,600,800', 'sans-serif']
  }
});

const initialiseApp = async () => {
  if (await auth.ensureAppAuthenticated()) {
    const container = document.getElementById('root');
    if (container) {
      const root = createRoot(container);
      root.render(<MainApp />);
    }
  }
};

initializeIcons();
initialiseApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
